import 'core-js/es6/map';
import 'core-js/es6/set';

import React from 'react';
import ReactDOM from 'react-dom';
import store from './store';
import { Provider } from 'react-redux';

import "babel-polyfill";
import 'font-awesome/css/font-awesome.css'
import './styles/index.css';

import App from './containers/App';
import loadInitialApis from './config/applicationLoader';

import {unregister} from './registerServiceWorker';

import Device from "./devices/device";

import LocalStorage from '../src/components/DeviceStorage/LocalStorage';
import DeviceStorage from '../src/components/DeviceStorage/DeviceStorage';
import AAF from '../src/AAF/AAF';
import pkg from '../package.json';

const STALE_DOMAIN = "http://aaf-cvideo-tv-stale.clarovideo.net";
const FORCED_STALE_DEVICES = ['arris', 'zeasn', 'netrange'];

if (process.env.NODE_ENV === 'production') {
  FORCED_STALE_DEVICES.push('workstation');
}

async function ready() {
  const deviceObject = Device.getDevice();
  const device = deviceObject.getPlatform();

  let subplatform = '';
  if(typeof deviceObject.getSubplatform === 'function') {
    subplatform = deviceObject.getSubplatform();
  }

  if (FORCED_STALE_DEVICES.includes(device)) {
    console.log(device, ' es STALE, se forza a irse a stale');
    // Redirect a stale
    location.href = STALE_DOMAIN;

    return;
    //deviceObject.disableArrisKeys();
  }

  window.appReq = {
    url: [],
    data: {},
  }

  //TODO obtener mejor el HKS desde la cadena search
  if (window.location && window.location.search && window.location.search.indexOf && window.location.search.indexOf('HKS') > -1) {
    if (window.location.search.split('=') && window.location.search.split('=')[1])
      localStorage.setItem('HKS', window.location.search.split('=')[1]);
  }

  //youbora
  window.youboraParams[11].value = deviceObject && deviceObject.config && deviceObject.config.firmwareversion || '';
  window.youboraParams[13].value = pkg.version || '';

  await loadInitialApis();
  ReactDOM.render(
    <Provider store={store}>
      <App />
    </Provider>,
    document.getElementById('root'),
    () => {
      if (
        window.AAFFallbackApplication &&
        window.AAFFallbackApplication.getNativeModalErrorTimeoutId() !== null
      ) {
        window.AAFFallbackApplication.clearNativeModalErrorTimeoutId();
      }
      if (
        window.AAFFallbackApplication &&
        window.AAFFallbackApplication.getNativeXDKRedirectTimeoutId() !== null
      ) {
        window.AAFFallbackApplication.clearNativeXDKRedirectTimeoutId();
      }

      root.classList.add(`root-${device}`);
      if (subplatform) {
        root.classList.add(`root-${subplatform}`);
      }
    }
  );
}

ready();

unregister();



// WEBPACK FOOTER //
// ./src/index.js